import { getUtcTime } from '@bingads-webui-universal/primitive-utilities';
import { constants } from '../constants';
import { Logger } from './logger';
import {
  IScenario, IActivity, TTraceLogArgs, ITraceLogger,
} from '../types';

/**
 * Default Trace Logger
 */
export class TraceLogger extends Logger implements ITraceLogger {
  /**
   * trace - logs passed in args as trace logs
   * @param {IScenario} scenario - scenario of activity that invoked log method
   * @param {IActivity} activity - activity that invoked the log method
   * @param {IScenario} parentScenario - parent of the scenario
   * @param {TTraceLogArgs} args - args passed in to the trace log method
   * @returns {void} - no returns
   */
  trace(
    scenario: IScenario,
    activity: IActivity,
    parentScenario: IScenario,
    [message, api, requestId, httpMethod, logLevel]: TTraceLogArgs,
  ): void {
    super.log({
      api,
      message,
      requestId,
      httpMethod,
      timeStamp: getUtcTime(),
      logCategory: constants.LOGCATEGORY.TRACE,
      logLevel: logLevel || constants.LOGLEVEL.INFO,
      entryType: constants.ENTRYTYPE.MESSAGE,
      activity,
      scenario,
      parentScenario,
    });
  }

  getLogMethods(): string[] {
    return ['trace'];
  }
}
